import { useI18n } from 'vue-i18n';
import { PersonType } from './types';

export const useGermanTaxPayerEntityOptions = () => {
  const { t } = useI18n();
  const personTypeOptions = [
    {
      value: PersonType.Legal,
      label: t('tax_payer_entity.form.person_type_options.legal'),
    },
    {
      value: PersonType.Natural,
      label: t('tax_payer_entity.form.person_type_options.natural'),
    },
  ];

  const formValues = [
    '31',
    '25',
    '26',
    '49',
    '20',
    '91',
    '92',
    '34',
    '36',
    '28',
    '81',
    '27',
    '35',
    '23',
    '24',
    '33',
    '22',
    '32',
    '41',
    '43',
    '61',
    '21',
    '72',
    '82',
    '74',
    '16',
    '44',
    '45',
    '99',
    '59',
    '83',
    '39',
    '73',
    '29',
    '79',
    '71',
    '37',
    '51',
    '42',
  ];

  const germanLegalFormOptions = formValues.map((value) => ({
    value,
    label: t(`tax_payer_entity.form.legal_forms.form_${value}`),
  }));

  const GermanSalutationOptions = [
    { value: '1', label: t('tax_payer_entity.form.salutation_options.mr') },
    { value: '2', label: t('tax_payer_entity.form.salutation_options.mrs') },
    {
      value: '3',
      label: t('tax_payer_entity.form.salutation_options.diverse'),
    },
  ];

  return {
    personTypeOptions,
    germanLegalFormOptions,
    GermanSalutationOptions,
  };
};
